import { render, staticRenderFns } from "./CampanhaToscana.vue?vue&type=template&id=3b3c38e4&"
import script from "./CampanhaToscana.vue?vue&type=script&lang=js&"
export * from "./CampanhaToscana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports